import * as Yup from 'yup';

const ClientSchema = Yup.object().shape({
  client_name: Yup.string().required('Name is required'),
  client_code: Yup.string().required('Code is required'),
  company_id: Yup.string().required('Company is required'),
});

export default ClientSchema;
